module.exports = __webpack_public_path__ + "img/ep-7.92ec9b3c.jpg";